import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Card } from 'components/core/Card';
import { Button } from 'components/core/Button';
import { H3, Paragraph } from 'components/core/Typography';
import { ReviewChart } from 'components/review/ReviewChart';

import ProsCons from './ProsCons';

import './reviewSummary.scss';

const proConShape = PropTypes.shape({
	name: PropTypes.string.isRequired,
	reviewCount: PropTypes.number.isRequired
});

export function ReviewSummary({
	className,
	ratingCounts,
	totalReviews,
	recommendedRate,
	pros,
	cons,
	facilityId
}) {
	return (
		<div className={classnames(className, 'review-summary')}>
			<Paragraph eyebrow>
				Reviews summary
			</Paragraph>
			<Card hideBorder>
				{!!totalReviews &&
					<div className="summary-content">
						<ReviewChart
							ratingCounts={ratingCounts}
							totalReviews={totalReviews}
						/>
						{typeof recommendedRate !== 'undefined' &&
							<Paragraph className="would-recommend">
								<strong>
									{recommendedRate}%
								</strong> of respondents would recommend this facility to a friend.
							</Paragraph>
						}
						<div>
							<ProsCons
								name="Pros"
								list={pros}
							/>
							<ProsCons
								name="Cons"
								list={cons}
							/>
						</div>
					</div>
				}
				<Paragraph>
					Help your fellow storage searchers make the right choice!
				</Paragraph>
				<Button
					href={`/review.html?fid=${facilityId}`}
					rel="nofollow"
				>
					Leave a review
				</Button>
			</Card>
		</div>
	);
}

ReviewSummary.propTypes = {
	className: PropTypes.string,
	pros: PropTypes.arrayOf(proConShape),
	cons: PropTypes.arrayOf(proConShape),
	ratingCounts: PropTypes.arrayOf(PropTypes.shape({
		rating: PropTypes.number.isRequired,
		count: PropTypes.number.isRequired
	})).isRequired,
	totalReviews: PropTypes.number.isRequired,
	facilityId: PropTypes.number.isRequired,
	recommendedRate: PropTypes.number
};

ReviewSummary.defaultProps = {
	pros: [],
	cons: []
};

export default ReviewSummary;
